import {match, Pattern} from 'ts-pattern';

import {isValidNumber} from 'ramda-adjunct';

import {Nullish} from 'shared/web';

import {FeatureStateFlagSeverity} from '../../../components/FeatureStateFlag/FeatureStateFlag';

export function getBrakeLiningWearSeverity(value: string | Nullish): FeatureStateFlagSeverity {
  const valueNumber = value ? Number(value) : null;

  if (isValidNumber(valueNumber)) {
    return match<typeof valueNumber, FeatureStateFlagSeverity>(valueNumber)
      .with(Pattern.number.between(0, 20), () => 'damaged')
      .with(Pattern.number.between(20, 50), () => 'warning')
      .with(Pattern.number.gt(50), () => 'ready')
      .otherwise(() => 'neutral');
  }

  return 'neutral' as const;
}
